import { useAuth } from '@/components/auth/authProvider';
import { isInternalUser } from '@/components/auth/RequireIsInternalUser';
import {
  PutOrganizationPaymentSetting,
  useGetOrganizationPaymentSettingsQuery,
  usePutOrganizationPaymentSettingMutation,
} from '@/services/organizations';
import { Box, Button, Card, TextInput, toast } from '@palmetto/palmetto-components';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const NetSuiteVendorIdSetting = () => {
  const { alias } = useParams<{ alias: any }>();
  const { data: paymentSettings, isLoading: isLoadingPaymentSettings } = useGetOrganizationPaymentSettingsQuery({
    alias,
  });
  const [setPaymentSetting] = usePutOrganizationPaymentSettingMutation();
  const { claims } = useAuth();
  const isInternal = isInternalUser(claims, true);
  const [netSuiteVendorId, setNetSuiteVendorId] = useState<string>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (paymentSettings?.netSuiteVendorId) {
      setNetSuiteVendorId(paymentSettings?.netSuiteVendorId);
    }
  }, [paymentSettings]);

  if (!isInternal) {
    return null;
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const savePayload: PutOrganizationPaymentSetting = {
      alias,
      paymentSettings: {
        paymentPlanId: paymentSettings?.paymentPlanId,
        inheritBankAccount: paymentSettings?.inheritBankAccount,
        inheritNetSuiteVendorId: paymentSettings?.inheritNetSuiteVendorId,
        inheritPaymentPlan: paymentSettings?.inheritPaymentPlan,
        payoutHold: paymentSettings?.payoutHold,
        netSuiteVendorId,
      },
    };

    try {
      await setPaymentSetting(savePayload).unwrap();
      toast.success('Payment Settings submitted successfully');
    } catch (e) {
      toast.error('Error submitting settings');
      console.error(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Box as="h3" fontWeight="medium" fontSize="md">
          NetSuite Vendor Id
        </Box>
      </Card.Header>
      <Card.Section>
        <Box direction="row" gap="md">
          <Box>
            <TextInput
              id="netsuite-vendor-id"
              label="NetSuite Vendor Id"
              value={netSuiteVendorId}
              hideLabel
              maxWidth="3xl"
              onChange={(e) => {
                setNetSuiteVendorId(e.target.value);
              }}
              disabled={isLoadingPaymentSettings || isSubmitting}
            />
          </Box>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isLoadingPaymentSettings}
            isLoading={isSubmitting}
          >
            Save
          </Button>
        </Box>
      </Card.Section>
    </Card>
  );
};
